import { takeEvery, cancel, put } from 'redux-saga/effects'
import { GET_LINKED_RPS } from 'actions/supportParameter'
import { getReferenceParam } from 'actions/referenceParameter'
import { getLogicalSlots } from 'actions/apiLookUpValues'

export default function* watchGetLinkedRPs() {
  yield takeEvery(GET_LINKED_RPS, getFirstLinkedReferenceParameter)
}

function* getFirstLinkedReferenceParameter({ data }) {
  const { referenceParameters } = data
  yield put(getLogicalSlots(referenceParameters[0]))
  if (referenceParameters.length < 1) yield cancel()

  const {
    refParameterNumber: referenceParameterNumber,
    release: releaseNumber,
  } = referenceParameters[0]
  yield put(getReferenceParam({ referenceParameterNumber, releaseNumber }))
}
